import React from 'react';
export function SellerCard() {
  return <div className="mt-6 border border-gray-200 rounded-xl p-4 bg-white" data-id="element-236">
      <div className="flex items-center justify-between mb-4" data-id="element-237">
        <div className="flex items-center gap-3" data-id="element-238">
          <div className="w-12 h-12 rounded-full bg-esbelta-lavender flex items-center justify-center border border-esbelta-violet/20 overflow-hidden" data-id="element-239">
            <img src="https://cdn.magicpatterns.com/uploads/suhcPXB4eKx8m116DtCqhf/WhatsApp_Image_2026-06-15_at_11.29.08_AM.jpg" alt="Pote ESBELTA®" className="w-full h-full object-contain p-1" data-id="element-240" />
          </div>
          <div data-id="element-241">
            <h3 className="font-bold text-gray-900 text-sm" data-id="element-242">
              ESBELTA ARGENTINA
            </h3>
            <p className="text-xs text-gray-500 font-medium" data-id="element-243">
              <span className="font-bold text-gray-700" data-id="element-244">+1000</span> Seguidores{' '}
              <span className="font-bold text-gray-700" data-id="element-245">+5</span> Productos
            </p>
          </div>
        </div>
        <button className="bg-blue-50 text-blue-600 font-semibold text-xs px-3 py-1.5 rounded-md hover:bg-blue-100 transition-colors" data-id="element-246">
          Siguiendo
        </button>
      </div>

      <div className="mb-3" data-id="element-247">
        <div className="flex items-center gap-1.5 mb-1" data-id="element-248">
          <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-249"></div>
          <span className="font-bold text-green-500 text-sm" data-id="element-250">
            MercadoLíder Platinum
          </span>
        </div>
        <p className="text-xs text-gray-500" data-id="element-251">¡Uno de los mejores del sitio!</p>
      </div>

      <div className="flex gap-1 mb-3" data-id="element-252">
        <div className="h-1.5 flex-1 bg-red-100 rounded-l-full" data-id="element-253"></div>
        <div className="h-1.5 flex-1 bg-orange-100" data-id="element-254"></div>
        <div className="h-1.5 flex-1 bg-yellow-100" data-id="element-255"></div>
        <div className="h-1.5 flex-1 bg-green-200" data-id="element-256"></div>
        <div className="h-1.5 flex-1 bg-green-500 rounded-r-full" data-id="element-257"></div>
      </div>

      <div className="flex justify-between text-center divide-x divide-gray-100" data-id="element-258">
        <div className="flex-1 px-1" data-id="element-259">
          <div className="font-bold text-gray-900 text-sm" data-id="element-260">+5mil</div>
          <div className="text-[10px] text-gray-500" data-id="element-261">Ventas</div>
        </div>
        <div className="flex-1 px-1" data-id="element-262">
          <div className="text-green-500 font-bold text-sm" data-id="element-263">✓</div>
          <div className="text-[10px] text-gray-500" data-id="element-264">Buena atención</div>
        </div>
        <div className="flex-1 px-1" data-id="element-265">
          <div className="text-green-500 font-bold text-sm" data-id="element-266">✓</div>
          <div className="text-[10px] text-gray-500" data-id="element-267">Entrega a tiempo</div>
        </div>
      </div>
    </div>;
}